import { action } from 'typesafe-actions';
import { AuthActionTypes } from './types';
import { IUser } from 'types';
import { ISessionContext } from 'shared-components/lib/authentication';

export const updateStudentNumber = (student_number: string) =>
  action(AuthActionTypes.CHANGE_STUDENT_NUM, student_number);
export const updateEmail = (email: string) => action(AuthActionTypes.CHANGE_EMAIL, email);
export const updatePassword = (password: string) => action(AuthActionTypes.CHANGE_PASSWORD, password);
export const clickMarketing = () => action(AuthActionTypes.CLICK_MARKETING);
export const clickTerms = () => action(AuthActionTypes.CLICK_TERMS);
export const login = (userName: string, password: string) =>
  action(AuthActionTypes.COGNITO_LOGIN_REQUEST, { userName, password });
export const reauth = () => action(AuthActionTypes.COGNITO_REAUTH_REQUEST);
export const authSuccess = (sessionContext: Omit<ISessionContext, 'getIdToken' | 'onLogout'>) =>
  action(AuthActionTypes.COGNITO_LOGIN_SUCCESS, { sessionContext });
export const logout = () => action(AuthActionTypes.LOGOUT_REQUEST);
export const logoutSuccess = () => action(AuthActionTypes.COGNITO_LOGOUT_SUCCESS);
export const logoutFailure = (message: string) => action(AuthActionTypes.COGNITO_LOGOUT_FAILURE, message);
export const resetPasswordRequest = (username: string, code: string, password: string) =>
  action(AuthActionTypes.RESET_PASSWORD_REQUEST, { username, code, password });
export const resetPasswordSuccess = () => action(AuthActionTypes.RESET_PASSWORD_SUCCESS);
export const resetPasswordFailure = (message: string) => action(AuthActionTypes.RESET_PASSWORD_FAILURE, message);
export const getCurrentUserRequest = () => action(AuthActionTypes.GET_CURRENT_USER_REQUEST);
export const getCurrentUserSuccess = (payload: IUser) => action(AuthActionTypes.GET_CURRENT_USER_SUCCESS, payload);
export const getCurrentUserFailure = (message: string) => action(AuthActionTypes.GET_CURRENT_USER_FAILURE, message);
export const changePasswordSuccess = () => action(AuthActionTypes.CHANGE_PASSWORD_SUCCESS);
export const changePasswordFailure = (message: string) => action(AuthActionTypes.CHANGE_PASSWORD_FAILURE, message);
